import type {PreviewConfiguration} from 'schema/types';
import type {
  Part,
  PartAction,
  PartSeparator,
  PreviewPart,
} from 'schemaDefinition/types';

export const isPartExcluded = (
  part: Part | undefined,
  config: PreviewConfiguration,
): boolean => {
  return !!(
    part &&
    part.name &&
    ((config.excludeParts &&
      config.excludeParts.includes(part.name.toString())) ||
      (config.includeParts &&
        !config.includeParts.includes(part.name.toString())))
  );
};

export const isPreviewPart = (
  part: PartSeparator | PartAction | Part,
): part is PreviewPart => {
  return part.type !== 'expand' && part.type !== 'action';
};

export const isIncludedPreviewPart = (
  part: PartSeparator | PartAction | Part,
  config: PreviewConfiguration,
): part is PreviewPart => {
  return (
    part.type === 'separator' ||
    (isPreviewPart(part) && !isPartExcluded(part, config))
  );
};
